import React, { useMemo } from 'react';
import { apiMessagesStore, useResourceError } from '@api/utils/ApiMessagesStore';
import QcsAlert from './common/basic/QcsAlert';
import { Resource } from '@api/resources';

interface Props {
  resource: Resource | Resource[];
  clearErrorOnExit?: boolean;
}

export const ShowError: React.FC<Props> = ({ resource, clearErrorOnExit = true }) => {
  // Memoize the resource to prevent clearing errors on parent re-renders
  // We use JSON.stringify for deep comparison of array contents - don't remove it
  const stableResource = useMemo(() => resource, [JSON.stringify(resource)]);

  const errors = useResourceError(stableResource, clearErrorOnExit);

  // Normalize resource to array for handleClose
  const resources = useMemo(() => (Array.isArray(stableResource) ? stableResource : [stableResource]), [stableResource]);

  if (errors.length === 0) return null;

  const handleClose = () => {
    resources.forEach((res) => apiMessagesStore.clearError(res));
  };

  return (
    <QcsAlert severity="error" onClose={handleClose}>
      {errors.map((error, index) => (
        <div key={index}>{error}</div>
      ))}
    </QcsAlert>
  );
};
